// veutify plugin file https://vuetifyjs.com/en/getting-started/quick-start#webpack-install
import Vue from 'vue';
import Vuetify from 'vuetify';
import VCalendar from 'v-calendar';

Vue.use(Vuetify);
Vue.use(VCalendar, {componentPrefix: 'vc'});

const opts = {
  icons: {
    iconfont: 'fa',
    values: {
      checkboxOff: 'fa fa-square-o',
      dropdown: 'fal fa-chevron-down',
      warning: 'far fa-exclamation-triangle'
    }
  },
  theme: {
    themes: {
      light: {
        primary: '#024ad8',
        accent: '#103fb2',
      },
    },
  }
};

export default new Vuetify(opts);
